import { type CellAddr, cellRefText, sheetRefPrefix, type Token, tokenize } from "@package/scratchpad-utils";
import type { CellRect } from "./picking";

function inRect(cell: CellAddr, rect: CellRect): boolean {
  return cell.col >= rect.x && cell.col < rect.x + rect.width && cell.row >= rect.y && cell.row < rect.y + rect.height;
}

export function retargetRefs(
  src: string,
  rect: CellRect,
  dCol: number,
  dRow: number,
  targetsCutSheet: (refSheet: string | undefined) => boolean,
): string {
  if (!src.startsWith("=")) return src;
  let tokens: Token[];
  try {
    tokens = tokenize(src.slice(1));
  } catch {
    return src;
  }
  let out = src;
  for (let i = tokens.length - 1; i >= 0; i--) {
    const t = tokens[i]!;
    if (t.kind !== "ref") continue;
    const { start, end } = t.addr;
    if (!targetsCutSheet(start.sheet)) continue;
    if (!inRect(start, rect) || (end && !inRect(end, rect))) continue;
    const moved = (c: CellAddr) => ({ ...c, col: c.col + dCol, row: c.row + dRow });
    const sheet = start.sheet ? sheetRefPrefix(start.sheet) : "";
    const text = `${sheet}${cellRefText(moved(start))}${end ? `:${cellRefText(moved(end))}` : ""}`;
    out = out.slice(0, t.span.start + 1) + text + out.slice(t.span.end + 1);
  }
  return out;
}
